module.exports = __webpack_public_path__ + "static/media/Hippie.aff68ff1.jpg";